module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"signup":"Registrieren","login":"Einloggen","hi":"Hi, ","logOut":"Abmelden"},"en":{"signup":"Sign up","login":"Log in","hi":"Hi, ","logOut":"Log out"}}')
  delete Component.options._Ctor
}
